
import { Component, computed, viewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatToolbarModule } from '@angular/material/toolbar';
import { PageWithNavigationComponent } from '../shared/page-templates/page-with-navigation/page-with-navigation.component';
import { ProjectListComponent } from './project-list/project-list.component';


@Component({
    selector: 'app-projects',
  imports: [ProjectListComponent, MatToolbarModule, MatIconModule, MatProgressBarModule, MatProgressSpinnerModule, MatMenuModule, MatButtonModule, PageWithNavigationComponent],
  templateUrl: './projects.component.html',
})

export class ProjectsComponent {
  private readonly projectList = viewChild(ProjectListComponent);
  readonly hasUnsavedChanges = computed(() => this.projectList()?.hasUnsavedChanges() ?? false);
  readonly isSaving = computed(() => this.projectList()?.processing() ?? false);

}
